import { ticketService } from '../api/ticketService';
import { queryClient } from './queryClient';

/** Stable query keys for session-scoped master/reference data. */
export const MASTER_DATA_KEYS = {
  statuses: ['statuses'],
  priorities: ['priorities'],
  categories: ['categories'],
};

/** Load once after login; keep in memory until logout. */
export const masterDataQueryOptions = {
  staleTime: Infinity,
  gcTime: Infinity,
  refetchOnWindowFocus: false,
  refetchOnReconnect: false,
  retry: 1,
};

/**
 * Extract list payload from existing ticketService response shapes.
 * Does not transform items — only unwraps arrays already produced by services.
 */
export function extractMasterDataArray(response) {
  if (!response) return [];

  if (response?.data?.success && response?.data?.data) {
    return Array.isArray(response.data.data) ? response.data.data : [];
  }

  const nested = response?.data?.data ?? response?.data;
  if (Array.isArray(nested)) {
    return nested;
  }

  if (response?.success && response?.data) {
    return Array.isArray(response.data) ? response.data : [];
  }

  return [];
}

export function fetchStatuses() {
  return queryClient.fetchQuery({
    queryKey: MASTER_DATA_KEYS.statuses,
    queryFn: () => ticketService.getTicketStatuses(),
    ...masterDataQueryOptions,
  });
}

export function fetchPriorities() {
  return queryClient.fetchQuery({
    queryKey: MASTER_DATA_KEYS.priorities,
    queryFn: () => ticketService.getTicketPriorities(),
    ...masterDataQueryOptions,
  });
}

export function fetchCategories() {
  return queryClient.fetchQuery({
    queryKey: MASTER_DATA_KEYS.categories,
    queryFn: () => ticketService.getTicketCategories(),
    ...masterDataQueryOptions,
  });
}

export function invalidateMasterDataCache(key) {
  if (key) {
    return queryClient.invalidateQueries({ queryKey: key });
  }
  return Promise.all([
    queryClient.invalidateQueries({ queryKey: MASTER_DATA_KEYS.statuses }),
    queryClient.invalidateQueries({ queryKey: MASTER_DATA_KEYS.priorities }),
    queryClient.invalidateQueries({ queryKey: MASTER_DATA_KEYS.categories }),
  ]);
}
